export enum CardStatus {
  Inactive = "INACTIVE",
  Active = "ACTIVE",
  Pending = "PENDING",
  Suspended = "SUSPENDED",
  PermBlock = "PERM_BLOCK",
}

export type CardDetail = {
  status: CardStatus;
  cardNumberLastDigits: string;
  cardholderName: string;
  cardOpaqueId: string;
  cardNumberOpaqueId: string;
  printRequestDate?: string;
  deliveryAddress?: string;
};
